<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <!-- <b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      /> -->
      <span class="locale-trigger">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      class="locale-item"
      :class="{ active: currentLocale.locale === localeObj.locale }"
      @click="changeLocale(localeObj.locale)"
    >
      <!-- <b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      /> -->
      <span class="locale-label">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from "bootstrap-vue";
import { localize } from "vee-validate";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  setup() {
    /* eslint-disable global-require */
    const locales = [
      {
        locale: "en",
        // img: require("@/assets/images/flags/en.png"),
        name: "EN",
      },
      {
        locale: "es",
        // img: require("@/assets/images/flags/es.png"),
        name: "ES",
      },
      // {
      //   locale: 'fr',
      //   img: require('@/assets/images/flags/fr.png'),
      //   name: 'French',
      // },
      // {
      //   locale: 'de',
      //   img: require('@/assets/images/flags/de.png'),
      //   name: 'German',
      // },
      // {
      //   locale: 'pt',
      //   img: require('@/assets/images/flags/pt.png'),
      //   name: 'Portuguese',
      // },
    ];
    /* eslint-disable global-require */

    return {
      locales,
    };
  },

  computed: {
    currentLocale() {
      return (
        this.locales.find((item) => item.locale === this.$i18n.locale) ||
        this.locales.find((item) => item.locale === "es")
      );
    },
  },

  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale;

      try {
        localStorage.setItem("locale", locale);
      } catch (error) {
        // ignore storage errors
      }

      localize(locale);
    },
  },
};
</script>

<style scoped>
.dropdown-language {
  display: flex;
  align-items: center;
  position: relative;
}

.dropdown-language ::v-deep .dropdown-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 46px;
  height: 32px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(40, 169, 224, 0.1);
  border: 1px solid rgba(40, 169, 224, 0.2);
  transition: all 0.2s ease;
}

.dropdown-language ::v-deep .dropdown-toggle:hover {
  background: rgba(40, 169, 224, 0.18);
  border-color: rgba(40, 169, 224, 0.35);
}

.dropdown-language ::v-deep .dropdown-toggle:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(40, 169, 224, 0.18);
}

.dropdown-language ::v-deep .dropdown-menu {
  position: absolute !important;
  top: calc(100% + 0.45rem) !important;
  right: 0 !important;
  bottom: auto !important;
  left: auto !important;
  width: 92px !important;
  min-width: 92px !important;
  padding: 0.35rem;
  margin: 0;
  transform: none !important;
  border: 1px solid rgba(34, 41, 47, 0.08);
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(34, 41, 47, 0.14);
  overflow: hidden;
  z-index: 1050;
}

.locale-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #28a9e0;
}

.locale-item {
  width: 100%;
  padding: 0;
  margin: 0.1rem 0;
  border-radius: 7px;
  cursor: pointer;
  overflow: hidden;
}

.locale-item ::v-deep .dropdown-item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 0.45rem 0.65rem;
  border-radius: 7px;
  background: transparent;
  color: #5e5873;
  transition: background-color 0.16s ease, color 0.16s ease;
}

.locale-item:hover ::v-deep .dropdown-item,
.locale-item ::v-deep .dropdown-item:hover,
.locale-item ::v-deep .dropdown-item:focus {
  background: rgba(40, 169, 224, 0.1);
  color: #1a7bbd;
  outline: none;
}

.locale-item.active ::v-deep .dropdown-item {
  background: rgba(40, 169, 224, 0.16);
  color: #1685bd;
}

.locale-item.active .locale-label {
  color: #1a7bbd;
}

.locale-label {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: inherit;
}

@media (max-width: 991.98px) {
  .dropdown-language.show {
    position: relative !important;
  }

  .dropdown-language ::v-deep .dropdown-toggle {
    min-width: 44px;
    height: 30px;
    padding: 0 8px;
  }

  .dropdown-language.show ::v-deep .dropdown-menu.dropdown-menu-right {
    position: absolute !important;
    top: calc(100% + 0.45rem) !important;
    right: 0 !important;
    left: auto !important;
    width: 92px !important;
    min-width: 92px !important;
    transform: none !important;
  }

  .locale-trigger,
  .locale-label {
    font-size: 0.78rem;
  }

  .locale-item ::v-deep .dropdown-item {
    min-height: 32px;
    padding: 0.4rem 0.55rem;
  }
}
</style>
